import { combineReducers } from "redux";
import AddTourReducer from "./AddTourReducer";

export default combineReducers({
  AddTourReducer: AddTourReducer,
});
